/* Apple-style PDP — vanilla JS port of the Claude Design React prototype.
   Scope: scroll reveals, hero parallax, sticky sub-nav, reels carousel,
   offers carousel dots, customer-reviews pagination/filter, promo countdown. */
(function () {
  if (window.__applePdpInit) return;
  window.__applePdpInit = true;

  // ===== Reveal on scroll =====
  function initReveal() {
    var reveal = function (el) {
      if (el.classList.contains('in')) return;
      el.classList.add('in');
      el.style.opacity = '1';
      el.style.transform = 'none';
    };
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal,.reveal-up,.reveal-scale').forEach(reveal);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    var observe = function () {
      document.querySelectorAll('.reveal:not(.in),.reveal-up:not(.in),.reveal-scale:not(.in)')
        .forEach(function (el) { io.observe(el); });
    };
    observe();
    var mo = new MutationObserver(observe);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.in),.reveal-up:not(.in),.reveal-scale:not(.in)').forEach(reveal);
    }, 1500);
  }

  // ===== Hero parallax (product 3D, hero photo, or hero video) =====
  function initHeroParallax() {
    var product = document.querySelector('.apdp-stage .product-3d, .apdp-stage .apdp-hero-video');
    if (!product) return;
    var onScroll = function () {
      var y = window.scrollY;
      product.style.transform = 'translateY(' + (y * 0.3) + 'px) scale(' + (1 - Math.min(y / 4000, 0.1)) + ')';
      product.style.opacity = String(Math.max(0.4, 1 - y / 1000));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ===== Hero video play/pause control + auto-pause out of viewport =====
  function initHeroVideo() {
    var video = document.querySelector('.apdp-stage .apdp-hero-video');
    if (!video) return;
    var toggle = document.querySelector('[data-apdp-hero-video-toggle]');
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      video.pause();
      if (toggle) toggle.classList.add('is-paused');
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          toggle.classList.remove('is-paused');
          toggle.setAttribute('aria-label', 'Mettre en pause');
        } else {
          video.pause();
          toggle.classList.add('is-paused');
          toggle.setAttribute('aria-label', 'Lancer la vidéo');
        }
      });
    }
    // Pause when hero scrolls out of view (saves CPU + battery on mobile)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!toggle || !toggle.classList.contains('is-paused')) video.play().catch(function(){});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.1 });
      io.observe(video);
    }
  }

  // ===== Product sub-nav: revealed after hero/bigword, sticky once visible =====
  function initSubNav() {
    var nav = document.querySelector('.product-subnav');
    if (!nav) return;
    var links = nav.querySelectorAll('a[href^="#"]');
    var ids = Array.prototype.map.call(links, function (a) { return a.getAttribute('href').slice(1); });
    var stickAfterAttr = parseInt(nav.getAttribute('data-stick-after') || '0', 10);

    // Dynamic threshold : prefer .apdp-bigword bottom, fallback : 70% of viewport, last : data-stick-after.
    function thresholdY() {
      var trigger = document.querySelector('.apdp-bigword') || document.querySelector('.apple-pdp-hero');
      if (trigger) {
        var rect = trigger.getBoundingClientRect();
        return rect.top + window.scrollY + rect.height; // = bottom of trigger absolute
      }
      if (stickAfterAttr > 0) return stickAfterAttr;
      return Math.min(window.innerHeight * 0.7, 700);
    }

    function setRevealed(on) {
      document.body.classList.toggle('psn-revealed', !!on);
      nav.classList.toggle('is-stuck', !!on);
    }
    function highlightActive() {
      var current = ids[0];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (el && el.getBoundingClientRect().top <= 120) current = ids[i];
      }
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + current);
      });
    }

    var onScroll = function () {
      setRevealed(window.scrollY > thresholdY());
      highlightActive();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    links.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var id = a.getAttribute('href').slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        ev.preventDefault();
        var top = el.getBoundingClientRect().top + window.scrollY - 88;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  // ===== Reels carousel arrows =====
  function initReels() {
    document.querySelectorAll('.reels-rail-wrap').forEach(function (wrap) {
      var rail = wrap.querySelector('.reels-rail');
      if (!rail) return;
      wrap.querySelectorAll('.reels-arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.classList.contains('left') ? -1 : 1;
          rail.scrollBy({ left: dir * 320, behavior: 'smooth' });
        });
      });
    });
  }

  // ===== Reels UGC video — autoplay muted, pause hors viewport =====
  function initReelsAutoplay() {
    var videos = document.querySelectorAll('[data-ugc-video]');
    if (!videos.length) return;
    var safePlay = function (v) {
      try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (_) {}
    };
    if (!('IntersectionObserver' in window)) {
      videos.forEach(safePlay);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) safePlay(e.target);
        else { try { e.target.pause(); } catch (_) {} }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { io.observe(v); });
  }

  // ===== Offers carousel dots (mobile) =====
  function initOffers() {
    var grid = document.querySelector('.offers-grid');
    var dots = document.querySelectorAll('.offers-carousel-dots .dot');
    if (!grid || !dots.length) return;
    var cards = grid.querySelectorAll('.offer-card');
    var center = function () {
      var c = grid.scrollLeft + grid.clientWidth / 2;
      var bestIdx = 0, bestD = Infinity;
      cards.forEach(function (card, i) {
        var cc = card.offsetLeft + card.clientWidth / 2;
        var d = Math.abs(cc - c);
        if (d < bestD) { bestD = d; bestIdx = i; }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('active', i === bestIdx); });
    };
    if (window.matchMedia('(max-width: 1000px)').matches) {
      var featured = grid.querySelector('.offer-card.featured');
      if (featured) {
        var target = featured.offsetLeft - (grid.clientWidth - featured.clientWidth) / 2;
        grid.scrollLeft = Math.max(0, target);
      }
    }
    grid.addEventListener('scroll', center, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var card = cards[i];
        if (!card) return;
        var t = card.offsetLeft - (grid.clientWidth - card.clientWidth) / 2;
        grid.scrollTo({ left: Math.max(0, t), behavior: 'smooth' });
      });
    });
    center();
  }

  // ===== Customer reviews — pagination + rating filter =====
  function initCustReviews() {
    var root = document.querySelector('.cust-reviews');
    if (!root) return;
    var perPage = parseInt(root.getAttribute('data-per-page') || '4', 10);
    var cards = Array.prototype.slice.call(root.querySelectorAll('.cust-rev-card'));
    var pagerWrap = root.querySelector('.cust-rev-pager');
    var foot = root.querySelector('.cust-rev-foot-meta');
    var distRows = root.querySelectorAll('.cust-rev-bar-row');
    var filterActive = root.querySelector('.cust-rev-filter-active');
    var filterClear = filterActive && filterActive.querySelector('button');
    var filterCount = filterActive && filterActive.querySelector('span');
    var page = 0;
    var filter = 'all';

    var visible = function () {
      return cards.filter(function (c) { return filter === 'all' || c.getAttribute('data-rating') === filter; });
    };

    var render = function () {
      var v = visible();
      var total = Math.max(1, Math.ceil(v.length / perPage));
      if (page >= total) page = total - 1;
      cards.forEach(function (c) { c.style.display = 'none'; });
      v.slice(page * perPage, (page + 1) * perPage).forEach(function (c) { c.style.display = ''; });
      // Pager
      if (pagerWrap) {
        pagerWrap.innerHTML = '';
        var prev = document.createElement('button');
        prev.className = 'cust-rev-pg-arrow';
        prev.setAttribute('aria-label', 'Page précédente');
        prev.disabled = page === 0;
        prev.textContent = '‹';
        prev.addEventListener('click', function () { if (page > 0) { page--; render(); } });
        pagerWrap.appendChild(prev);
        for (var i = 0; i < total; i++) (function (i) {
          var b = document.createElement('button');
          b.className = 'cust-rev-pg-num' + (i === page ? ' active' : '');
          b.textContent = String(i + 1);
          b.addEventListener('click', function () { page = i; render(); });
          pagerWrap.appendChild(b);
        })(i);
        var next = document.createElement('button');
        next.className = 'cust-rev-pg-arrow';
        next.setAttribute('aria-label', 'Page suivante');
        next.disabled = page >= total - 1;
        next.textContent = '›';
        next.addEventListener('click', function () { if (page < total - 1) { page++; render(); } });
        pagerWrap.appendChild(next);
      }
      if (foot) {
        var pageEl = foot.querySelector('[data-cust-rev-page]');
        var totalEl = foot.querySelector('[data-cust-rev-total]');
        if (pageEl) pageEl.textContent = String(page + 1);
        if (totalEl) totalEl.textContent = String(total);
      }
      if (filterActive) {
        filterActive.style.display = filter === 'all' ? 'none' : 'flex';
        if (filterCount) filterCount.textContent = 'Filtre actif · ' + filter + ' étoiles · ' + v.length + ' avis';
      }
      distRows.forEach(function (row) {
        row.classList.toggle('active', row.getAttribute('data-rating') === filter);
      });
    };

    distRows.forEach(function (row) {
      row.addEventListener('click', function () {
        var r = row.getAttribute('data-rating');
        filter = (filter === r) ? 'all' : r;
        page = 0;
        render();
      });
    });
    if (filterClear) filterClear.addEventListener('click', function () {
      filter = 'all'; page = 0; render();
    });

    render();
  }

  // ===== Promo countdown — pre-Mother's day rolling 5 days =====
  function initPromoCountdown() {
    var nodes = document.querySelectorAll('[data-promo-countdown]');
    if (!nodes.length) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var update = function () {
      var now = new Date();
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      var ms = midnight - now;
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      nodes.forEach(function (n) {
        n.textContent = h + 'h' + pad(m);
      });
    };
    update();
    setInterval(update, 30000);

    document.querySelectorAll('[data-promo-window]').forEach(function (n) {
      var which = n.getAttribute('data-promo-window');
      var d = new Date();
      if (which === 'start') d.setDate(d.getDate() - 5);
      n.textContent = d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' });
    });
  }

  // ===== ATC redirect to /cart (no drawer) =====
  function initAtcRedirect() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.appleAtc === '1') return;
      form.dataset.appleAtc = '1';
      form.addEventListener('submit', function (ev) {
        // Let Shopify's own handlers run; if a JS framework hijacks already, we don't double-handle.
        if (form.dataset.appleAtcSkip === '1') return;
        ev.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (res.ok) {
              window.location.href = '/cart';
            } else {
              console.warn('Add-to-cart error', res.body);
              alert(res.body && res.body.description ? res.body.description : 'Erreur — réessayez.');
            }
          })
          .catch(function (err) {
            console.error('ATC fetch failed', err);
          });
      });
    });
  }

  // ===== Init =====
  function init() {
    initReveal();
    initHeroParallax();
    initHeroVideo();
    initSubNav();
    initReels();
    initReelsAutoplay();
    initOffers();
    initCustReviews();
    initPromoCountdown();
    initAtcRedirect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
